/**
 * Application Entry Point
 * SpecReferenceID: FRONTEND-WEB-V1
 * Requirements: FRONTEND-WEB-V1-R01, FRONTEND-WEB-V1-R13
 *
 * Main entry point for Galen Portal frontend application.
 * FRONTEND-WEB-V1-R13: Registers service worker for offline capability.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';
import { registerServiceWorker } from './service-worker-registration';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline support (FRONTEND-WEB-V1-R13)
void registerServiceWorker({
  onSuccess: (registration) => {
    console.log('Galen Portal is ready for offline use', registration.scope);
  },
  onUpdate: () => {
    console.log('New version available. Please refresh to update.');
  },
  onError: (error) => {
    console.error('Service worker registration failed:', error);
  },
});
